// extracted by mini-css-extract-plugin
module.exports = {"InputWrapper":"CallToActionButtonForm_InputWrapper__avMUP","LastInputWrapper":"CallToActionButtonForm_LastInputWrapper__yfriO"};